import { DATA_ROOM_FOLDER_NAME_MAX_LENGTH } from 'src/enviroment/constants/constants'

/** Mirrors ramo-back `isValidFolderSegment`; unlike `folderNameSchema` it does not trim, since a picked name is sent as is. */
export const isValidFolderSegment = (segment: string): boolean =>
  segment.length > 0 &&
  segment.length <= DATA_ROOM_FOLDER_NAME_MAX_LENGTH &&
  segment.trim() === segment &&
  !segment.includes('/') &&
  !segment.includes('\\') &&
  segment !== '.' &&
  segment !== '..'
